import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import useAccessToken from "./useAccessToken";
import * as userRegActions from "../actions/userRegActions";

const UserReg = (props) => {
    const accessToken = useAccessToken();

    useEffect(() => {
        if (accessToken) {
            props.userRegActions.setAccessToken(accessToken);

            props.userRegActions.receiveTokens(accessToken, accessToken);
        }
    }, [accessToken, props.userRegActions]);

    useEffect(() => {
        if (props.license.licenseChecked === true && props.license.tenantSignedUp === true && props.license.validLicense === false) {
            console.log("WE GOT AN INVALID LICENSE...");
            props.history.push("/novalidlicense");
        } else if (props.license.licenseChecked === true && props.license.tenantSignedUp === false) {
            console.log("THIS TENANT NEVER REGISTERED...");
            props.history.push("/notenantregistration");
        } else if (props.license.licenseChecked === true) {
            console.log("License valid.");
        }
    }, [props.license, props.history]);

    useEffect(() => {
        if (props.license.licenseChecked === false && props.userReg.exchangeToken) {
            const values = queryString.parse(props.location.search);
            console.log('Values: ', values);
            let licenseToken = values.et;
            if (licenseToken) {
                licenseToken = licenseToken.slice(0, -1);
            }
            console.log('Got this licenseToken: ' + licenseToken);
            props.userRegActions.checkLicense(licenseToken);
        }
    }, [props.license.licenseChecked, props.userReg.exchangeToken, props.location.search, props.userRegActions]);

    return (
        <div data-ssotoken={props.userReg.ssoToken} data-exchangetoken={props.userReg.exchangeToken} data-validlicense={props.license.validLicense.toString()}>
        </div>
    );
};

UserReg.propTypes = {
    userRegActions: PropTypes.object,
    userReg: PropTypes.object,
    license: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
};

const mapStateToProps = (state) => ({
    userReg: state.userRegTokens,
    license: state.userRegLicense,
});

const mapDispatchToProps = (dispatch) => ({
    userRegActions: bindActionCreators(userRegActions, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserReg));